import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/features/requets/shared/request.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-show-file',
  templateUrl: './show-file.component.html',
  styleUrls: ['./show-file.component.scss']
})
export class ShowFileComponent implements OnInit {
  src: any;
  enabledSpinner = true;
  messageError = '';
  extension: String;
  file: string;

  constructor(private requestService: RequestService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(
      (params) => {
        const cedula = params['cedula'];
        this.file = params['file'];
        const splitFile = this.file.split('.');
        this.extension = splitFile[splitFile.length - 1];
        this.file = this.file.substring(0, this.file.length - this.extension.length - 1);
        this.getFile(cedula, this.file);
      }
    );
   }

  ngOnInit() {
  }
  private getFile(cedula, file) {
    this.requestService.getFile(cedula, file).subscribe(

      (result) => {
        this.enabledSpinner = false ;
        if (result.data) {
          if (result.data.trim().length > 0) {
            this.src = encodeURI(result.data);
            this.showPdf(this.src);
          } else {
            this.messageError = 'Por favor comuniquese con el adminstrador del sistema';
          }
        }
      }
    );

  }
 private  showPdf(data) {
   // Si es internet Expolore descargar el archivo
   if (this.detectIE()) {
       const downloadLink = document.createElement('a');
       const fileName = this.file + '.' + this.extension;
       downloadLink.href = data;
       downloadLink.download = fileName;
       downloadLink.click();

   } else {
      const pdfWindow = window.open('', this.file);
      if (this.extension !== 'pdf') {
        pdfWindow.document.write('<!DOCTYPE html>  <img width=\'100%\' height=\'100%\' src=\'' + encodeURI(data) + '\'></img>');
      } else {
        pdfWindow.document.write('<iframe width=\'100%\' height=\'100%\' src=\'' + encodeURI(data) + '\'></iframe>');
      }
      window.close();
   }
  }


  private detectIE() {
    const ua = window.navigator.userAgent;
    // Test values; Uncomment to check result …
    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
    // IE 12 / Spartan
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
    // Edge (IE 12+)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
    // Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
  }
}
